import { useApiClient } from '../composables/useApiClient.ts';

export default {
    getClients(config?: Record<string, any>) {
        return useApiClient().get('/crms', config);
    },
    getStatuses() {
        return useApiClient().get('/crms/statuses');
    },
    getStaff() {
        return useApiClient().get('/staffs', { params: { list: true } });
    },
    getCrmFormTypes() {
        return useApiClient().get('/crms/crm-form-type');
    },
    addClient(data) {
        return useApiClient().post('/crms', { crm: { ...data } });
    },
    getClient(id: number) {
        return useApiClient().get(`/crms/${id}`);
    },
    updateClient(id: number, data: any) {
        return useApiClient().put(`/crms/${id}`, { crm: { ...data } });
    },
    deleteClient(id: number) {
        return useApiClient().delete(`/crms/${id}`);
    },
    getZusByPeriod(period: string) {
        return useApiClient().post('/crms/zus-employers/by-period', { period });
    },
};
